jQuery(document).ready(function ($) {
    const $carousels = $('.room-details__carousel');

    if (!$carousels.length) return;

    const mobile_breakpoint = window.matchMedia('(max-width: 768px)');
    const instances = new Map();

    function create_carousels() {
        $carousels.each(function () {
            if (instances.has(this)) return;

            const $carousel = $(this);

            instances.set(this, new Swiper(this, {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 12,
                centeredSlides: true,
                loop: $carousel.find('.swiper-slide').length > 1,
                grabCursor: true,
                focusableElements: 'input, select, option, textarea, button, label'
            }));
        });
    }

    function destroy_carousels() {
        instances.forEach(function (swiper) {
            swiper.destroy(true, true);
        });

        instances.clear();
    }

    function handle_breakpoint_change(event) {
        if (event.matches) {
            create_carousels();
        } else {
            destroy_carousels();
        }
    }

    if (mobile_breakpoint.matches) {
        create_carousels();
    }

    mobile_breakpoint.addEventListener('change', handle_breakpoint_change);
});
